import React from "react";
import { Animate } from "react-move";

class AnimatedProgressProvider extends React.Component {
  interval = undefined;
  state = {
    prevValue: this.props.valueStart, // Keep track of previous value
  };
  static defaultProps = {
    valueStart: 0,
  };
  componentDidUpdate(prevProps) {
    if (prevProps.valueEnd !== this.props.valueEnd) {
      // Update state only when valueEnd changes
      this.setState({ prevValue: prevProps.valueEnd });
    }
  }
  componentWillUnmount() {
    window.clearInterval(this.interval);
  }
  render() {
    return (
      <Animate
        start={() => ({
          value: this.state.prevValue, // Start from last progress
        })}
        update={() => ({
          value: [this.props.valueEnd],
          timing: {
            duration: this.props.duration * 1000,
            ease: this.props.easingFunction,
          },
        })}
      >
        {({ value }) => this.props.children(value)}
      </Animate>
    );
  }
}

export default AnimatedProgressProvider;